import { PluginSetup as UIAttributePluginSetup } from '@leverege/ui-attributes';
import { PluginSetup as UIAttributeGraphsPluginSetup } from '@leverege/ui-attributes-graphs';
import { PluginSetup as ConditionPluginSetup } from '@leverege/condition';
import { PluginSetup as UIConditionPluginSetup } from '@leverege/ui-condition';
import { PluginSetup as UILoginSetup } from '@leverege/api-ui-login';
import { PluginSetup as StylePluginSetup } from '@leverege/ui-style-elements';
// eslint-disable-next-line import/no-cycle
import { PluginSetup } from "./plugins/index.js";
const install = cfg => {
  UIAttributePluginSetup.install(cfg);
  UIAttributeGraphsPluginSetup.install(cfg);
  // UIUserManagement.install( cfg )
  ConditionPluginSetup.install(cfg);
  UIConditionPluginSetup.install(cfg);
  UILoginSetup.install(cfg);
  StylePluginSetup.install(cfg);
  PluginSetup.install(cfg);
};
export default {
  install
};